<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Último movimiento por bin</v-card-title>
      <v-card-text>
        <v-row>
            <v-col cols="4">
                <v-btn @click="download" color="primary">Excel</v-btn>
            </v-col>
            <v-col cols="4">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Escriba para filtrar bins"
                    single-line
                    hide-details
                ></v-text-field>
            </v-col>
        </v-row>
        
        <v-data-table
            :headers="movimientosListHeaders"
            :items="movimientosListBody"
            class="elevation-1"
            dense
            no-data-text="No hay movimientos"
            :search="search"
        >
          <template v-slot:[`item.fecha`]="{item}">
            {{ formatDate(item.fecha)}}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
        search: null,
        start_date: new Date().toISOString().substr(0, 10),
        isLoading: false,
        url_excel: '',
        movimientosListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'fecha',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Guia',
          align: 'center',
          sortable: true,
          value: 'guia',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Movimiento',
          align: 'center',
          sortable: true,
          value: 'movimiento',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Planta',
          align: 'center',
          sortable: true,
          value: 'planta',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Color',
          align: 'center',
          sortable: true,
          value: 'color',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Tamaño',
          align: 'center',
          sortable: true,
          value: 'size',
          class: "salmon black--text elevation-3"
        },
        {
          text: '# Bin',
          align: 'center',
          sortable: true,
          value: 'number',
          class: "salmon black--text elevation-3"
        },
      ],
      movimientosListBody: [],
    }),
    mounted() {
      this.loadMovements();
    },
    methods:{
      async loadMovements(){
        this.mostrarLoading('Generando informe, por favor espere...');
        let url = `${this.base_url}reports/movimientos/bins`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.movimientosListBody = response.data.data.report_data;
            this.url_excel = this.storage_url + response.data.data.url_excel;
            this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
    }
  }
</script>